<div class="forbidden">
  <div class="forbidden__shell" aria-labelledby="forbidden-title">
    <div class="forbidden__header">
      <div class="forbidden__mark" aria-hidden="true">
        <ng-glyph name="lock" size="28"></ng-glyph>
      </div>
      <div>
        <p class="forbidden__eyebrow">Error 403</p>
        <h1 id="forbidden-title" class="forbidden__title">Access restricted</h1>
      </div>
    </div>

    <app-card class="forbidden__card" [padded]="false">
      <div class="forbidden__content">
        <p class="forbidden__desc">
          Your current account does not include the required authorization to access this page or perform this action.
        </p>

        <div class="forbidden__divider"></div>

        <div class="forbidden__details" aria-label="Suggested next steps">
          <div class="forbidden__detail">
            <ng-glyph name="check_circle" size="20"></ng-glyph>
            <span>Confirm that you are using the correct admin account.</span>
          </div>
          <div class="forbidden__detail">
            <ng-glyph name="supervisor_account" size="20"></ng-glyph>
            <span>Contact an administrator if you need access to this area.</span>
          </div>
        </div>

        <div class="forbidden__actions" aria-label="Navigation actions">
          <app-button routerLink="/home">
            <ng-glyph name="home" size="20"></ng-glyph>
            Go to dashboard
          </app-button>
          <app-button routerLink="/profile" variant="secondary">
            <ng-glyph name="person" size="20"></ng-glyph>
            View profile
          </app-button>
        </div>
      </div>
    </app-card>
  </div>
</div>
